<template>
<div class="chapter">
<div class="inner_page">
<p class="P_ZNB_ChapterTextStyle__And__No_Hyphenation__And__Centre_Alignment"><span><span style=" font-family: 'Bell MT'; font-size: 4.80em;">DRAGONESQUE</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section-0001.vue?e3efd30c